import { Table } from "antd";
import moment from 'moment';
import DateUtil from "../../util/DateUtil";
import 'moment-timezone';
import React, { useState, useEffect } from 'react';
import LZString from 'lz-string';
import logo from './../../assets/img/favicon-dark.png';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from "../../routes/SessionManager";
import API from '../../service/SiteKickAPIService';

function WindReport() {

    const getPathParams = () => {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }
    const [loading, setLoading] = useState(true);
    const [wind_recs, setWindRecs] = useState([]);
    const [user, setUser] = useState(getPathParams());
    const [coordinates, setCoordinates] = useState("");

    let sessionManager = new SessionManager();
    sessionManager.storeCookie('user', user);


    let timezone = user.site_selected ? user.site_selected.site_iana_timezone : moment.tz.guess();
    let report_columns = [
        {
            title: "Date",
            dataIndex: 'local_epoch',
            key: 'local_epoch',
            render: (local_epoch, rec) => moment.tz(parseInt(local_epoch) * 1000, timezone).format('MMM DD, YYYY HH:mm')
        },
        {
            title: "Wind",
            dataIndex: 'wind',
            key: 'wind',
            render: (wind, rec) => {
                return <span>{wind}</span>
            }
        },
        {
            title: "Speed(mph)",
            dataIndex: 'wind_mph',
            key: 'wind_mph',
            render: (wind_mph, rec) => wind_mph
        },
        {
            title: "Gust(mph)",
            dataIndex: 'gust_speed',
            key: 'gust_speed',
            render: (wind_mph, rec) => {
                let gust_speed = rec.wind.split(" ");
                return <span>{gust_speed[8]}</span>
            }
        },
        {
            title: "Direction",
            dataIndex: 'wind_direction',
            key: 'wind_direction',
            render: (wind_direction, rec) => {
                return <span>{wind_direction}</span>
            }
        }
    ];

    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        setUser(user);
        fetchWeatherReport();
    }, []);

    const fetchWeatherReport = () => {
        setLoading(true);
        let start_ts = DateUtil.getDbData(timezone, user.date);
        var end_date = moment(user.date).add(1, 'days').format('YYYY-MM-DD');
        let end_ts = DateUtil.getDbData(timezone, end_date);

        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ['local_epoch', 'wind', 'wind_direction', 'wind_degrees', 'wind_mph', 'json_extract(full_response, \'$.coord\') as coordinates'],
                    object: 'weather_log',
                    filters: [
                        { attribute: 'local_epoch', value: start_ts, operator: '>=' },
                        { join_by: 'and', attribute: 'local_epoch', value: end_ts, operator: '<=' }
                    ],
                    sort_by: [{ attribute: 'local_epoch', value: 'asc' }],
                    pagination: { page: 1, size: 100 }
                })
            }
        }

        CommonUtils.ajax(
            {
                url: API.DATA.EXPLORER,
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let parseCoord = "";
                    if (res.data.length > 0) {
                        let coord = res.data[0].coordinates;
                        parseCoord = coord;
                    }
                    let wind_recs = [];
                    for (const wind of res.data) {
                        let windInfo = wind.wind.split(" ");
                        switch (true) {
                            case parseInt(windInfo[1]) === 0:
                                wind.wind = `From the N at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'N'
                                break;
                            case parseInt(windInfo[1]) > 0 && parseInt(windInfo[1]) < 90:
                                wind.wind = `From the NE at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'NE'
                                break;
                            case parseInt(windInfo[1]) === 90:
                                wind.wind = `From the E at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'E'
                                break;
                            case parseInt(windInfo[1]) > 90 && parseInt(windInfo[1]) < 180:
                                wind.wind = `From the SE at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'SE'
                                break;
                            case parseInt(windInfo[1]) === 180:
                                wind.wind = `From the S at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'S'
                                break;
                            case parseInt(windInfo[1]) > 180 && parseInt(windInfo[1]) < 270:
                                wind.wind = `From the SW at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'SW'
                                break;
                            case parseInt(windInfo[1]) === 270:
                                wind.wind = `From the W at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'W'
                                break;
                            case parseInt(windInfo[1]) > 270:
                                wind.wind = `From the NW at ${windInfo[3]} MPH Gusting to ${windInfo[6]} MPH`
                                wind.wind_direction = 'NW'
                                break;
                            default:
                                break;
                        }
                        wind_recs.push(wind);
                    }
                    setWindRecs(wind_recs);
                    setLoading(false);
                    setCoordinates(parseCoord);
                }
            });
    }

    const setPDFContentReady = () => {
        window.status = 'ready';
    }

    return (
        <React.Fragment>
            <div className="container">
                <div className="row">
                    <div className="col-md-12 my-5">
                        <span className="navbar-brand text-primary">
                            <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                            {"SiteSupt OnDemand"}
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12  p-1 mb-5">
                        <h4>Wind Report</h4>
                    </div>
                    <div className="col-md-12">
                        <h5 className="text-app">{user && user.site_selected && user.site_selected.site_name}</h5>
                    </div>
                </div>
                {!loading && coordinates && <div className="row p-1">
                    <div className="col-md-6 pt-1" style={{ paddingLeft: "12px" }}>
                        <b>Coordinates:</b>&nbsp;
                        <span className="font-size-5">
                            <label >Latitude:</label>&nbsp;<span>{coordinates.lat}, </span>
                        </span>
                        <span className="font-size-5">
                            <label >Longitude:</label>&nbsp;<span>{coordinates.lon}</span>
                        </span>
                    </div>
                    <div className="col-md-6 pt-1" style={{ paddingLeft: "14rem" }}>
                        <span >
                            <b >Source:</b>&nbsp;
                            <span>OpenWeather</span>
                        </span>
                    </div>
                </div>}
                <div className="row bg-white">
                    <div className="col-md-12 p-1">
                        <Table
                            loading={loading}
                            rowKey="local_epoch"
                            dataSource={wind_recs}
                            columns={report_columns}
                            pagination={false}
                        />
                    </div>
                </div>
                {!loading && setPDFContentReady()}
            </div>
        </React.Fragment>
    );
}

export default WindReport;